import { useRouteMatch } from "react-router-dom"
import type { DigitsRoute, RouteParams } from "@digits-shared/components/Router/DigitsRoute"
import type { PathGenerator } from "@digits-shared/hooks/usePathGenerator"

export type RoutePatchMatch = [string, boolean]

export const useRoutePathAndMatch = (
  generatePath: PathGenerator,
  route: DigitsRoute,
  params?: RouteParams
): RoutePatchMatch => {
  const path = generatePath(route, params)
  const isActive = !!useRouteMatch(route.parameterizedPath)
  return [path, isActive]
}

/**
 * Utility function to determine the active path from an array of route matches.
 * Returns the path of the first active route, or the fallback's path.
 *
 */
export function findActivePath(routeMatches: RoutePatchMatch[], fallback: RoutePatchMatch): string {
  const activeRoute = routeMatches.find(([_, isActive]) => isActive)
  return activeRoute ? activeRoute[0] : fallback[0]
}
